// Testi dell'audio del verbale (piano 2), in un solo posto perché si possano cambiare senza
// toccare i componenti. Il promemoria del consenso è ESATTO (spec, vincoli globali del piano 2).

/** Nome di un audio nella pagina: il nome del file caricato, altrimenti «Registrazione N». */
export const nomeAudio = (a: { origine: string; nomeOriginale: string | null; ordine: number }) =>
  (a.origine === 'file' && a.nomeOriginale) || `Registrazione ${a.ordine || 1}`;

export const TESTO_CONSENSO_REGISTRAZIONE =
  'Informa i presenti che la riunione viene registrata per redigere il verbale. '
  + 'L\'audio viene trascritto da un servizio di intelligenza artificiale esterno (OpenAI) '
  + 'e cancellato dalla piattaforma dopo 5 giorni.';

export const ETICHETTA_CONSENSO = 'Ho informato i presenti';

/** `accept` della scelta del file (il server riconosce comunque il formato dai byte). */
export const FORMATI_ACCETTATI = '.m4a,.mp3,.wav,.ogg,.opus,.webm,audio/*';
export const TESTO_FORMATI = 'm4a, mp3, wav, ogg, opus o webm, fino a 1 GB';

export const TESTO_IN_REGISTRAZIONE = 'In registrazione';
/** Registrazione dall'app con il telefono vivo (pezzo o battito negli ultimi 10 minuti). */
export const TESTO_REGISTRA_TELEFONO = 'Si sta registrando dal telefono';
/** Registrazione dall'app ferma da oltre 10 minuti (telefono spento o senza rete). */
export const TESTO_TELEFONO_FERMO = 'La registrazione era sul telefono: i minuti rimasti sul telefono si potranno inviare come nuova registrazione';
export const TESTO_IN_PAUSA = 'In pausa';

/** Istruzione rapida dell'editor che usa la trascrizione (Task 14). */
export const ISTRUZIONE_RIPRENDI = 'Riprendi dalla trascrizione';

export const TESTO_TRASCRIZIONE_PARZIALE = 'Trascrizione parziale: l\'audio è scaduto prima della fine';
export const TESTO_SENZA_VOCI = 'Trascrizione senza voci: gli interventi si attribuiscono in revisione';
export const TESTO_VOCI_FACOLTATIVE = 'Puoi generare il verbale anche senza associare le voci';
export const TESTO_GENERA_SOSTITUISCE = 'Il verbale attuale viene salvato nelle versioni e sostituito';
export const TESTO_GENERA_INTERROTTO = 'Interrotto, riprova';
/** Impaginazione o generazione che prosegue sul server senza la finestra (anche piano 1, «Ho già un testo»). */
export const TESTO_GENERAZIONE_SUL_SERVER = 'La generazione continua sul server: il verbale si aggiornerà da solo quando finisce.';
/** «Genera verbale» con un'altra generazione o impaginazione già in corso (409). */
export const TESTO_GENERAZIONE_GIA_IN_CORSO = 'È già in corso una generazione: il verbale si aggiornerà da solo';
/** Avviso della pagina mentre il server impagina o genera il verbale. */
export const TESTO_GENERAZIONE_IN_CORSO_PAGINA =
  'Generazione in corso sul server: il foglio è bloccato e si aggiornerà da solo quando finisce.';
export const TESTO_SOLO_IN_MEMORIA =
  'Alcuni blocchi della registrazione non sono salvati su questo computer: non chiudere la pagina finché non sono stati inviati';
/** Riprese senza file: i numeri delle parti seguono le riprese (come nell'email di preavviso). */
export const TESTO_PARTI_MANCANTI =
  'Le parti sono numerate come le riprese della registrazione: quelle rimaste senza audio non hanno un file da scaricare.';

const due = (n: number) => String(n).padStart(2, '0');

const data = (valore: string | Date | null | undefined): Date | null => {
  if (!valore) return null;
  const d = valore instanceof Date ? valore : new Date(valore);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** `29/10` (ora locale). */
export function giornoMese(valore: string | Date | null | undefined): string {
  const d = data(valore);
  return d ? `${due(d.getDate())}/${due(d.getMonth() + 1)}` : '';
}

/** `21:48` (ora locale). */
export function oraMinuti(valore: string | Date | null | undefined): string {
  const d = data(valore);
  return d ? `${due(d.getHours())}:${due(d.getMinutes())}` : '';
}

export const testoTrascrizioneInCorso = (fatti: number, totali: number) =>
  (totali > 0 ? `Trascrizione in corso: ${fatti} tratti su ${totali}` : 'Trascrizione in corso');

export const testoConservazione = (scadeIl: string | Date) =>
  `Conservata fino al ${giornoMese(scadeIl)}. Il giorno prima ti mandiamo un'email per scaricarla.`;

export const testoAudioEliminato = (eliminatoAt: string | Date) =>
  `Audio eliminato il ${giornoMese(eliminatoAt)}: la trascrizione resta`;

export const testoInterrotta = (alle: string | Date) => `Registrazione interrotta alle ${oraMinuti(alle)}`;

export const testoBlocchiInAttesa = (n: number) =>
  (n === 1 ? '1 blocco in attesa di invio' : `${n} blocchi in attesa di invio`);
